import React from 'react';
import logo from './images/navlogo.jpg';
import './index.css';
import { Routes,Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar'
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import OurCenters from './pages/OurCenters';
import ContactUs from './pages/ContactUs';
import Gallery from './pages/Gallery';
import Schemes from './pages/Schemes';
import Magazines from './pages/Magazines';
import Events from './pages/Events';
import StudentsZone from './pages/StudentsZone';
import Celebrating50Years from './pages/Celebrating50Years';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import AdminHomePage from './pages/AdminHomePage';
import AdminCenters from './pages/AdminCenters';
import AdminEvents from './pages/AdminEvents';
import AdminForms from './pages/AdminForms';
import FormApplications from './pages/FormApplications';

const App = () => {

  return (
    <div className="min-h-screen bg-white">

    <Routes>
      <Route path="/" element={<><Navbar logo={logo}/><Home/><Footer/></>}/>
      <Route path="/about-us" element={<><Navbar logo={logo}/><AboutUs/><Footer/></>}/>
      <Route path="/academy-schemes" element={<><Navbar logo={logo}/><Schemes/><Footer/></>}/>
      <Route path="/news-events" element={<><Navbar logo={logo}/><Events/><Footer/></>}/>
      <Route path="/magazines" element={<><Navbar logo={logo}/><Magazines/><Footer/></>}/>
      <Route path="/contact-us" element={<><Navbar logo={logo}/><ContactUs/><Footer/></>}/>
      <Route path="/our-centers" element={<><Navbar logo={logo}/><OurCenters/><Footer/></>}/>
      <Route path="/students-zone" element={<><Navbar logo={logo}/><StudentsZone/><Footer/></>}/>
      <Route path="/form-applications" element={<><Navbar logo={logo}/><FormApplications/><Footer/></>}/>
      <Route path="/celebrating-50-years" element={<><Navbar logo={logo}/><Celebrating50Years/><Footer/></>}/>
      <Route path="/press-note-2026" element={<><Navbar logo={logo}/><Celebrating50Years/><Footer/></>}/>

      <Route path="/login" element={<><Navbar logo={logo}/> <Login/> <Footer/></>}/>

      <Route path="/admin-dashboard" element={<ProtectedRoute element={<AdminDashboard/>} />} />
      <Route path="/admin-dashboard/home-page" element={<ProtectedRoute element={<AdminHomePage/>} />} />
      <Route path="/admin-dashboard/events" element={<ProtectedRoute element={<AdminEvents/>} />} />
      <Route path="/admin-dashboard/magazines" element={<ProtectedRoute element={<AdminEvents/>} />} />
      <Route path="/admin-dashboard/jobs" element={<ProtectedRoute element={<AdminEvents/>} />} />
      <Route path="/admin-dashboard/learning-material" element={<ProtectedRoute element={<AdminEvents/>} />} />
      <Route path="/admin-dashboard/centers" element={<ProtectedRoute element={<AdminCenters/>} />} />
      <Route path="/admin-dashboard/forms" element={<ProtectedRoute element={<AdminForms/>} />} />
 
      <Route path="/gallery" element={<><Navbar logo={logo}/><Gallery/><Footer/></>}/>
    </Routes>


    </div>
  );
};

export default App;